module.exports = __webpack_public_path__ + "37425e2a7fbddfadd251cd421f73c408.jpg";